import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const MultiplexersDemultiplexers = () => (
  <DSDModuleSubtopic
    title="Multiplexers and De multiplexers"
    videos={[
      "https://www.youtube.com/embed/aQlF-9i3fAA",
      "https://www.youtube.com/embed/eeWHM3zzK3M"
    ]}
    takeaways={[
      { text: "Learn the implementation high level mux/demux from low level mux/demux" },
      { text: "Learn the implementation of Boolean function from mux/demux" }
    ]}
    questions={[
      {
        text: "Implement the following Boolean Function using a Multiplexer F(A,B,C,D) = ∑ (0,1,5,6,9,11,12,13,14). Also write the Verilog Code using Conditional Operator"
      },
      {
        text: "Implement the following Boolean Function (Y) with an 8 x 1 Multiplexer and external NAND Gates Y(A,B,C,D) =∏ M(0,1,2,4,5,6,7,11,12,13,15). Realize the same function using 4 x 1 Multiplexer"
      },
      {
        text: "Design the following Boolean function using 4:1 Multiplexer (MUX). Assume the input “a” and “c” are select lines of the MUX. F(a,b,c,d) = ∑ m(0,1,2,5,8,9,11,12,14) Design the above function F using 1:8 Demultiplexers"
      },
      {
        text: "Design a combinational circuit whose output (F) is equal to 1 if the three input variables have more 1’s than 0’s. The output is 0 otherwise. Assume three inputs, x, y, and z. (i) Implement the above circuit using logic gates and (ii) using 1x8 De-Multiplexer which is constructed using two 1X4 De-Multiplexer"
      },
      {
        text: "Implement the function F= A'B'C'D' + AB + AC + AD + CBD by using one 4:1 Multiplexer with B and D as the selection lines and using external gates. And also write the Verilog HDL gate level for the design"
      },
      {
        text: "Implement the following Boolean function with a 4 x 1 Multiplexer and external gates F(A,B,C,D)=∑(1,2,4,7,12,13,14,15)+ d(0,3,5)"
      },
      {
        text: "Implement the following Boolean Function with a 4 x 1 multiplexer and external gates F = ∑ (1,3,5,7,9,11,13,15). Connect inputs A and B to the selection lines and the remaining input combinations of C and D to the data lines"
      },
      {
        text: "Implement the following Boolean Function with a 4 x 1 Multiplexer and external gates F(A,B,C,D)= ∑ (1,3,4,11,12,13,14,15)"
      },
      {
        text: "Write a Structural Level Verilog Code to implement 4:1 MUX using 2:1 MUX"
      },
      {
        text: "Implement the Boolean Expression f=(wxy+w'x'y')z + z'(x'y+w'x) using 4:1 MUX"
      },
      {
        text: "Draw the block diagram of 16 x 1 Multiplexer using 4 x1 Multiplexers. Write Verilog HDL for a 4 x 1 Multiplexer using case statement. Write a Structural Verilog Code for a 16 x 1 MUX using 4 x 1 MUX"
      },
      {
        text: "Implement the following Boolean Function F(A,B,C,D) = ∑ m (1,3,5,10,12) using 4x1 MUX and 2x1 MUX. No other logic gate is allowed except NOT Gate"
      },
      {
        text: "Implement the following Boolean Function F(A,B,C,D) = ∑ m(2,4,9,14,15) using i) 1:16 Demultiplexer ii) 4:16 Decoder"
      },
      {
        text: "Design a 1:32 DEMUX using 1:8 DEMUX. Here control the enable input of 1:8 DEMUX using a 1:4 DEMUX. Implement the following combination logic circuit using 1:32 DEMUX F(A,B,C,D,E) = ∑ m (0,1,7,15,23,31)"
      },
      {
        text: "Implement the logic function F(a,b,c) = ∑ m(1,2,3,5,6,7) using 4:1 MUX with following selection line conditions i) b and c as selection ii) a and c as selection iii) a and b as selection"
      },
      {
        text: "Write the SOP and POS Boolean expression for the given circuit in canonical and standard forms (i) Design the given circuit using three 8:1 Multiplexers (ii) Design 8:1 Multiplexer using 4:1 Multiplexers (iii) Design 4:1 Multiplexer circuit using 2:1 Multiplexer circuit (iv) Construct the internal circuit of 2:1 Multiplexer using two input NAND Logic",
        image:"/dsd_12.png"
      },
      {
        text: "Design a combinational logic circuit using 4x1 MUX and external gates for implementing the logic function F(A,B,C,D). The logic function F decides whether a four bit input binary number is divisible by 2 or divisible by 3 or by both. Connect A and B to the select inputs"
      }
    ]}
    exampleVideos={[]}
  />
);

export default MultiplexersDemultiplexers;
